import { ServiceHandler } from '../../../utils/api.utils';
import { getData } from '../../../utils/functional/fp';

export interface NextPromptRequest {
  userMessage: string;
  assistantText: string;
}

export interface NextPromptResponse {
  suggestion: string | null;
}

const nextPromptRequest = ServiceHandler<NextPromptRequest, NextPromptResponse>(
  {
    url: '/api/chat-agent/v1/conversations/:conversationId/next-prompt',
    method: 'POST',
  }
);

/** Guesses the user's next prompt after a finished turn. */
export async function suggestNextPrompt(
  conversationId: string,
  body: NextPromptRequest,
  signal?: AbortSignal
): Promise<NextPromptResponse> {
  const res = await nextPromptRequest(conversationId, { data: body, signal });
  return getData(res) as NextPromptResponse;
}
